module.exports = __webpack_public_path__ + "static/media/lantern.6634ca6f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/lantern.png
// module id = 133
// module chunks = 0